import type { FaireProductEntity } from "../../entity_types/product";

export const p_q34z9t6gse: FaireProductEntity = {
  token: "p_q34z9t6gse",
  type: "product",
  name: "Lantern sleeves color-blocking knit cardigan",
  brandToken: "b_m8aq2q3qv8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f786f84571455b00c90b407bdfe05df7b9f56eb1d643cd4627d6ace522ab6c4a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/219e27e97d779db231413f2aad54662d8af91f3eca67eb85591e58ea62051c90.jpeg",
    "https://cdn.faire.com/fastly/95801ccb2da37f58886ec09d7986a607fc479dc0de7eac574dea42337e9c3296.jpeg",
    "https://cdn.faire.com/fastly/ed35e4ac3c9866fa940d9224da80491e699e414c983ffca961b04eb9e123d6f1.jpeg",
    "https://cdn.faire.com/fastly/edd2bde5eb75ae05675c7e7f48fe83d4e2939c024299606da807273bb94eb7d0.jpeg",
    "https://cdn.faire.com/fastly/733dedab4d2cf2af4fc9fb7bffe55836b3b066ad7a64e7427e8722767d7bcd31.jpeg",
    "https://cdn.faire.com/fastly/608907d554cc85970563e71b84b88b5b9c4cf703ea3b72f32af8ccdfd32d3691.jpeg",
    "https://cdn.faire.com/fastly/cc22dec02093bf3b8c62434fb8032b24471e22c7927e3da7acb07846e160d9b1.jpeg",
    "https://cdn.faire.com/fastly/4f5f44260d1a576d397796009bc50686a7b0948e944c459d531f2dae3555fbde.jpeg",
    "https://cdn.faire.com/fastly/77d423d635f7aa0f8fef2d1d223978ec2c644576bcb985a82cf506bfde2fcf93.jpeg",
    "https://cdn.faire.com/fastly/df8b497cdc83a0075a0a006bfbce2f1b0eef7e9a9e0ee433ff075456cf2dba32.jpeg",
    "https://cdn.faire.com/fastly/f72cbe4eaddcadbd51c49f86cf4380b0f9fe072c8ffa8ff365f3a21e1eb433ac.jpeg",
    "https://cdn.faire.com/fastly/5ce7d15cd0b4536f048cf1bbbb2b40b53f2b7991c9ccad87aa11d2ae5555e6a7.jpeg",
    "https://cdn.faire.com/fastly/8b09ff8d07e6ea4837aa716367b1ed6536fb38ff65b1879758eb3766b8863878.jpeg",
    "https://cdn.faire.com/fastly/072d8489a81a2d7bce68d3b4e89ab89838e3dc237cc217284cb26555eedd3aa8.jpeg",
    "https://cdn.faire.com/fastly/747536fdcfcb8190035fa7b202b819b53df3e9bcb77317e199e5488e253cc9b4.jpeg",
    "https://cdn.faire.com/fastly/5a9a9a984b0886d92ab9d6c10a5a7fb84935097991fff4ae1c5560147e68fe1a.jpeg",
  ],
  priceDollars: 30.65,
  description:
    "Lantern sleeves color-blocking knit cardigan\n100% POLYESTER\nSIZES : S,M,L,XL\nMADE IN CHINA\n\nCardigan, women's cardigan, cardigan, large size cardigan, knitted cardigan, oversized cardigan, cardigan hoodie, summer cardigan, short cardigan, long cardigan, spring cardigan, 2024 new cardigan, winter cardigan, fashionable women's cardigan, cardigan shirt, cardigan button down cardigan, loose cardigan, summer cardigan, knitted outerwear, cardigan with pockets，cardigan sweater，mens cardigan，folklore cardigan，black cardigan，red cardigan，white cardigan，womens cardigan，cropped cardigan，       crochet cardigan，long cardigan，cashmere cardigan，granny square cardigan，oversized cardigan，knit cardigan，womens cardigan sweaters，chunky cardigan，gray cardigan，long cardigan clothing，lightweight cardigan，cropped cardigan sweater，crochet cardigan pattern",
  tags: [],
  msrpDollars: 61.3,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:17.098Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
